import { render } from "./ServiceClassLayout.vue?vue&type=template&id=b94f3e74&scoped=true"
import script from "./ServiceClassLayout.vue?vue&type=script&lang=js"
export * from "./ServiceClassLayout.vue?vue&type=script&lang=js"

import "./ServiceClassLayout.vue?vue&type=style&index=0&id=b94f3e74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b94f3e74"]])

export default __exports__